var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrapper"},[_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox","value":"1","name":_vm.name},domProps:{"checked":_vm.checked},on:{"click":_vm.onChange}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }